document.addEventListener('DOMContentLoaded', function() {
  // Show popup on AJAX Add to Cart success
  function showCartPopup(cart) {
    // Build product list HTML
    let itemsHtml = cart.items.map(item => `
      <div style="display:flex; align-items:center; margin-bottom:18px;">
        <img src="${item.image}" style="width:80px; height:60px; object-fit:cover; border-radius:6px;" />
        <div style="margin-left:15px; flex:1;">
          <div style="font-weight:bold;">${item.product_title}</div>
          <div>$${item.price/100}</div>
          <div>QTY: <span>${item.quantity}</span> <a href="#" data-id="${item.id}" class="cart-popup-remove" style="margin-left:10px; color: #274632;">Remove</a></div>
        </div>
      </div>
    `).join('');
    let subtotal = `$${cart.total_price/100}`;
    let content = `<h3>Added to your bag</h3>${itemsHtml}<hr><div>Subtotal (${cart.item_count} items): <strong class="csapps-cart-original-total">${subtotal}</strong></div>`;
    document.getElementById('cart-popup-content').innerHTML = content;
    document.getElementById('cart-popup-modal').style.display = 'block';
  }

//   Listen for Add to Cart button
//  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
//    form.addEventListener('submit', function(e) {
//      e.preventDefault();
//      let formData = new FormData(form);
//      fetch('/cart/add.js', {
//        method: 'POST',
//        body: formData
//      })
//      .then(() => fetch('/cart.js'))
//      .then(resp => resp.json())
//      .then(showCartPopup);
//    });
//  });
$(document).on('click', '.cart-drawer button', function () {
    fetch('/cart.js')
      .then(resp => resp.json())
      .then(showCartPopup);
});

  // Close popup
  document.getElementById('cart-popup-close').onclick = function() {
    document.getElementById('cart-popup-modal').style.display = 'none';
  };

  // Go to cart page
  document.getElementById('view-full-bag').onclick = function() {
    window.location.href = '/cart';
  };

  // Remove item from cart inside popup
  document.body.addEventListener('click', function(e) {
    if(e.target.classList.contains('cart-popup-remove')) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: e.target.dataset.id, quantity: 0 })
      })
      .then(() => fetch('/cart.js'))
      .then(resp => resp.json())
      .then(showCartPopup);
    }
  });
});
